import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthRoutes, RouteParamsTypes, Modules, NonAuthRoutes } from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import GlobalConfigPage from '../modules/system/global-config';
import BrandingForm from '../modules/system/branding';
import DataManagement from '../modules/system/data-management';

const System: React.FC = () => {
  return (
    <Routes>
      <Route
        path={AuthRoutes.globalConfig}
        element={<ProtectedRoute component={GlobalConfigPage} />}
      />
      <Route
        path={AuthRoutes.branding}
        element={<ProtectedRoute component={BrandingForm} />}
      />
      <Route
        path={AuthRoutes.dataManagement}
        element={<ProtectedRoute component={DataManagement} />}
      />
      <Route
        path={RouteParamsTypes.blank}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default System;
